module.exports = __webpack_public_path__ + "media/images/icons/outlined/user-932c719590a5f81f4347239062998bdb.svg";